import React from 'react';
import '../styles/Modal.css';

function Modal({ isOpen, closeModal, children, width }) {
  return (
    <>
      {isOpen && (
        <div className="modal-wrapper" onClick={closeModal}>
          <div
            className="modal-content"
            style={{ width }}
            onClick={(e) => e.stopPropagation()} // Prevent the click event from bubbling up to the overlay
          >
            {/* <span className="close" onClick={closeModal}>
              &times;
            </span> */}
            {children}
          </div>
        </div>
      )}
    </>
  );
}

export default Modal;
